export { default } from './Typography';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Typography/index.js
// module id = 84
// module chunks = 121